
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

import './CardFeatures.css';
import { Icon } from '../../types/shared/Icon';
import { Col, Row } from '../../importCL';

interface IFeature {
    icon?: Icon;
    topic?: string;
    subtopic?: string;
}

interface ICardFeaturesProps extends MappedComponentProperties {
    heading?: string;
    imagePath?: string;
    imageAltText?: string;
    features?: IFeature[];
}

export const CardFeaturesEditConfig = {
    emptyLabel: 'Card Features',
    isEmpty: (props: PropsWithChildren<ICardFeaturesProps>) => {
        return !props || !props.heading;
    }
};

const CardFeatures = (props: PropsWithChildren<ICardFeaturesProps>): JSX.Element => {
    return (
        <div className='CardFeatures pt-10 md:-mx-3 mx-0'>
            <h2 className='mb-8 pl-4 TextLine__leftBorder flex items-center'>{props.heading}</h2>
            <Row>
                <Col className='CardFeatures__image mb-6 px-0'>
                    <img src={props.imagePath} alt={props.imageAltText} className={`object-cover ${props.features?.length === 2 ? 'aspect-3/2' : 'aspect-square'}`} />
                </Col>
                <Col md={6}>
                    {props.features?.map((feature, index) => {
                        return <Row key={index} className='p-6 mb-4 md:mb-6 mx-4 md:mx-0 border rounded-lg border-grey-chalice border-solid'>
                            <Col md={2} sm={1} xs={1} className='m-auto md:m-0 !p-0'>
                                {feature.icon && <img src={feature.icon.iconPath} alt={feature.icon.iconAltText} />}
                            </Col>
                            <Col>
                                <b className='mb-4'>{transformHTMLParserLinks(feature.topic)}</b>
                                {transformHTMLParserLinks(feature.subtopic)}
                            </Col>
                        </Row>
                    })}
                </Col>
            </Row>
        </div>
    );
};

export default CardFeatures;
        